<div class="flex flex-col gap-[1.25rem] bg-(--p-white) rounded-[0.5rem] border border-transparent"
     [ngClass]="{'!border-(--p-primary-50) p-[0.75rem]': showBorder()}">
  <div class="flex flex-col gap-[0.5rem] self-start">
    <span class="text-[0.75rem] font-[600] text-(--p-primary-300) leading-[150%]"
      translate="@@shared-last-modified-by">
    </span>

    <gc-comment-author [name]="authorName()" [date]="authorDate()" />
  </div>

  <div class="flex flex-col gap-1 self-start w-full">
    @if (showCommentLabel()) {
      <div class="text-[0.75rem] font-[600] leading-[150%] text-(--p-primary-400)" translate="@@shared-comment-label"></div>
    }

    <div class="flex flex-col w-full gap-[0.5rem]">
      <p gcTruncationDetector #truncation="gcTruncationDetector" style="display: -webkit-box; -webkit-box-orient: vertical;"
        class="overflow-hidden
          whitespace-pre-line
          text-[0.75rem]
          font-semibold
          text-(--p-gray-950)
          leading-[1.5]"
        [class.line-clamp-12]="truncateMessage()">
        {{ message() }}
      </p>

      @if (showReadMoreButton()) {
        <p-button
          [text]="true"
          class="self-end"
          severity="contrast"
          styleClass="!h-7
          !px-1.5
          !py-1
          !gap-0
          !text-(--p-primary-500)
          hover:!bg-(--p-neutral-500)
          hover:!border-(--p-primary-100)"
          (click)="readMore.emit()">
        <span class="text-(--p-primary-500) text-[0.6875rem] font-medium leading-4 ml-1"
              [translate]="truncation.isTruncated() ? '@@shared-read-more' : '@@shared-view-details'"></span>

          <svg-icon src="icons/icon-arrow-right.svg" class="text-(--p-primary-500)" name="icon-arrow-right"></svg-icon>
        </p-button>
      }
    </div>
  </div>
</div>
